import React, {useEffect, useState} from 'react';
import Alert from '@material-ui/lab/Alert';

export const CapaIniAlert = ({formikProps, ...props}) => {
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('warning');
  const {
    values: {included_capa_ini},
  } = formikProps;

  useEffect(() => {
    if (included_capa_ini === true) {
      setMessage('Este curso se incluirá en la capacitación inicial');
      setSeverity('info');
    } else {
      setMessage('Este curso no se incluirá en la capacitación inicial');
      setSeverity('warning');
    }
  }, [included_capa_ini, setMessage]);

  return <Alert severity={severity}>{message}</Alert>;
};
